import {makeStyles, createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

const styles = (theme: Theme) =>
    createStyles({
        preloader: {
            maxWidth: 120
        },
        select: {
            display: 'flex',
            alignItems: 'center'
        },
        menuItem: {
            display: 'flex',
            alignItems: 'center'
        },
        periodIcon: {
            marginRight: theme.spacing(),
            color: '#ccc'
        }
    });

export const useStyles = makeStyles(styles);
